import {
  Box,
  Center,
  Container,
  Flex,
  HStack,
  Icon,
  Image,
  LinkBox,
  LinkOverlay,
  Spacer,
  Text,
  VStack,
  Separator,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Link } from 'gatsby-plugin-jaen';
import { Field } from 'jaen';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaGithub } from '@react-icons/all-files/fa/FaGithub';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaPhone } from '@react-icons/all-files/fa/FaPhone';
import Logo from '../../gatsby-plugin-jaen/components/Logo';

/**
 * Footer component.
 */
const Footer: FC = () => {
  // The year is the build's, not the visitor's clock. A browser that renders
  // another year than the server HTML is a hydration mismatch on every page,
  // and the next build moves the year on anyway.
  const { site } = useStaticQuery<{ site: { buildTime: string } }>(graphql`
    query FooterBuildYear {
      site {
        buildTime(formatString: "YYYY")
      }
    }
  `);

  const links = [
    [
      {
        label: 'Seiten',
        isTitle: true
      },
      {
        label: 'Startseite',
        href: '/'
      },
      // {
      //   label: 'LinkedIn',
      //   href: 'https://www.linkedin.com/in/kleberbaum/'
      // },
      // {
      //   label: 'Telegram',
      //   href: 'https://t.me/kleberbaum'
      // },
      {
        label: 'Angebot',
        href: '/#angebot'
      },
      {
        label: 'Ablauf',
        href: '/#ablauf'
      },
      {
        label: 'Praxis',
        href: '/#praxis'
      },
      {
        label: 'Blog',
        href: '/docs'
      },
      // {
      //   label: 'Mitgliederbereich',
      //   href: '/imprint'
      // },
      {
        label: 'FAQ',
        href: '/#faq'
      },
      {
        label: 'Über mich',
        href: '/#blog-slider'
      },
      {
        label: 'Kontakt',
        href: '/?contact'
      },
      {
        label: 'Impressum',
        href: '/imprint'
      }
    ],
    [
      {
        label: 'Expert:innen',
        isTitle: true
      },
      {
        label: 'Netsnek',
        href: 'https://netsnek.com'
      },
    ]
  ]

  const linkElmnts: ReactNode[] = []

  links.forEach((linkGroup, i) => {
    linkElmnts.push(
      <VStack gap={3} alignItems="start" wrap="wrap" key={i}>
        {linkGroup.map((link, i) => {
          if ('isTitle' in link) {
            return (
              <Field.Text
                key={i}
                color="white"
                name={'FooterLinkTitle' + link.label}
                defaultValue={link.label}
                fontWeight="500"
              />
            )
          }
          return (
            <Link
              key={i}
              href={link.href}
              variant="pq-footer"
              color="white"
              opacity={0.7}
            >
              <Field.Text
                color="white"
                name={'FooterLink' + link.label}
                defaultValue={link.label}
              />
            </Link>
          )
        })}
      </VStack>
    )
  })

  return (
    <>
      <Box
        borderTopRadius="2xl"
        borderTop="1px solid"
        borderColor="brand.800"
        pb={20}
        position="relative"
        //mt="-25px"
        px={{base: 5, lg: 0}}
        overflowX="hidden"
        bgColor="brand.900"
        zIndex={0}>
        <Container maxW="7xl" h="100%">
          <Flex mt={20} wrap={{base: 'wrap', sm: 'nowrap'}}>
            <Box>
              <Flex alignItems={'center'}>
                <Logo color="white" h="100px" />
              </Flex>
            </Box>
            <Spacer minW={{base: '5rem', lg: '25%'}} />
            <HStack
              alignItems="start"
              gap={{base: 5, sm: 20}}
              wrap={{base: 'wrap', md: 'nowrap'}}
              mt={{base: 10, md: 0}}>
              {linkElmnts}
            </HStack>
          </Flex>
          {/* <Stack
            mt={20}
            as={LinkBox}
            direction={'row'}
            spacing="0"
            mx="-12px"
            flexWrap={'wrap'}>
            <IconButton
              as={LinkOverlay}
              size="lg"
              variant={'ghost'}
              color="#ffffff"
              icon={<Netsnek w={'25px'} h={'25px'} />}
              aria-label="Netsnek"
              href="https://netsnek.com/schett"
              isExternal
            />
            <IconButton
              as={LinkOverlay}
              size="lg"
              variant={'ghost'}
              color="#ffffff"
              icon={<FaGithub />}
              aria-label="Github"
              href="https://github.com/schettn/"
              isExternal
            />
            <IconButton
              as={LinkOverlay}
              size="lg"
              variant={'ghost'}
              color="#ffffff"
              icon={<FaInstagram />}
              aria-label="Instagram"
              href="https://www.instagram.com/barbara.mauz/"
              isExternal
            />
            <IconButton
              as={LinkOverlay}
              size="lg"
              variant={'ghost'}
              color="#ffffff"
              icon={<FaTelegram />}
              aria-label="Telegram"
              href="https://t.me/schettn"
              isExternal
            />
          </Stack> */}
          <HStack
            //justifyContent={"flex-end"}
            color={'white'}
            mt={20}
            gap="4"
            flexWrap={'wrap'}
            asChild><LinkBox>
              <LinkBox
                mr="4"
                display="flex"
                transition="color 0.2s"
                _hover={{
                  color: 'brand.500'
                }}>
                <LinkOverlay href="mailto:office@nadine-hauswirth.com">
                  <Icon boxSize="5" asChild><FaEnvelope /></Icon>
                </LinkOverlay>
              </LinkBox>
              <LinkBox
                mr="4"
                display="flex"
                transition="color 0.2s"
                _hover={{
                  color: 'brand.500'
                }}>
                <LinkOverlay href="tel:+436603840488">
                  <Icon boxSize="5" asChild><FaPhone /></Icon>
                </LinkOverlay>
              </LinkBox>
              {/* <LinkBox
                mr="4"
                display="flex"
                transition="color 0.2s"
                _hover={{
                  color: 'brand.500'
                }}>
                <LinkOverlay href="https://twitter.com/netsnek_com" isExternal>
                  <Icon as={FaTwitter} boxSize="5" />
                </LinkOverlay>
              </LinkBox>
              <LinkBox
                mr="4"
                display="flex"
                transition="color 0.2s"
                _hover={{
                  color: 'brand.500'
                }}>
                <LinkOverlay href="https://github.com/netsnek" isExternal>
                  <Icon as={FaGithub} boxSize="5" />
                </LinkOverlay>
              </LinkBox> */}
            </LinkBox></HStack>
          <Separator mt={8} opacity={0.2} />
          <Field.Text
            name="FooterBottomText"
            defaultValue={`Copyright © ${site.buildTime} Netsnek e.U. All rights reserved.`}
            mt={5}
            color="white"
            opacity={0.2}
            _hover={{
              opacity: 1
            }}
            cursor="default"
            transition="opacity 0.2s ease-in-out"
          />
        </Container>
      </Box>
    </>
  );
}

export default Footer;
